import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { AppStorage } from 'app/utilities/storage';

@Pipe({
    name: 'localDatetime',
    standalone: false
})
@Injectable({
	providedIn: 'root',
})
export class LocalDatetimePipe implements PipeTransform {

  transform(date: number | string | Date): string {
    const locale = AppStorage.getLocalStorageDataRaw('X-User-Locale') || 'en-US';
    
    const dateStr = new Date(date).toLocaleDateString(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const timeStr = new Date(date).toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${dateStr} ${timeStr}`;
  }
}
